import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { navegarComCtrl } from "../../utils/solicitacoes/navegacao";
import { CustomTable } from "../../componentes/table/CustomTable";
import { CustomDropdown } from "../../componentes/dropdown/CustomDropdown";
import StatusBadge from "../../components/solicitacoes/Shared/StatusBadge";
import GraficosBasicos from "../../components/solicitacoes/Dashboard/GraficosBasicos";
import DashboardProcessoLayout, { Campo, INPUT_CLASS } from "../../components/solicitacoes/Dashboard/DashboardProcessoLayout";
import { useDashboardProcesso } from "../../hooks/solicitacoes/useDashboardProcesso";
import ChamadoTIService from "../../services/resource/chamadoTIService";
import TipoServicoTIService from "../../services/resource/tipoServicoTIService";
import UsuarioService from "../../services/resource/usuarioService";
import { STATUS_CONFIG } from "../../utils/solicitacoes/statusConfig";
import { kpisBasicos } from "../../utils/solicitacoes/chartOptions";

const service = new ChamadoTIService();
const tipoServicoService = new TipoServicoTIService();
const usuarioService = new UsuarioService();

const STATUS_OPTIONS = Object.entries(STATUS_CONFIG).map(([value, info]) => ({ value, label: info.label }));

const STATUS_FINALIZACAO_LABELS = { RESOLVIDO: "Resolvido", NAO_RESOLVIDO: "Não Resolvido" };

const FILTROS_INICIAIS_EXTRA = { resumo: "", tipoServicoId: null, status: null, solicitanteId: null };

const COLUNAS = [
    { key: "resumo", label: "Resumo" },
    { key: "tipoServicoNome", label: "Tipo de Serviço" },
    { key: "statusFinalizacao", label: "Resultado", render: v => STATUS_FINALIZACAO_LABELS[v] || v || "-" },
    { key: "status", label: "Status", render: v => <StatusBadge status={v} />, center: true },
    { key: "etapaAtual", label: "Etapa Atual" },
    { key: "solicitanteNome", label: "Solicitante" },
    { key: "dataSolicitacao", label: "Data", format: "date" },
];

export default function RelatorioChamadoTI() {
    const navigate = useNavigate();
    const [usuarios, setUsuarios] = useState([]);
    const [tiposServico, setTiposServico] = useState([]);

    const { filtros, setFiltros, limparFiltros, pesquisar, linhas, dashboard, loading } = useDashboardProcesso({
        service, chaveFiltros: "solicitacoes.chamadoTI.filtros", filtrosIniciaisExtra: FILTROS_INICIAIS_EXTRA,
    });

    useEffect(() => {
        document.title = "MyDash | Abertura de Chamado TI";
    }, []);

    useEffect(() => {
        usuarioService.listarUsuarios().then(res => setUsuarios(res.data)).catch(() => setUsuarios([]));
        tipoServicoService.listar().then(res => setTiposServico(res.data)).catch(() => setTiposServico([]));
    }, []);

    function setFiltro(campo, valor) {
        setFiltros(prev => ({ ...prev, [campo]: valor }));
    }

    return (
        <DashboardProcessoLayout
            titulo="Abertura de Chamado TI"
            onNovaSolicitacao={() => navigate("/solicitacoes/nova")}
            loading={loading}
            filtros={filtros}
            onFiltroChange={setFiltro}
            onPesquisar={pesquisar}
            onLimparFiltros={limparFiltros}
            kpis={kpisBasicos(dashboard, "fa fa-headset")}
            graficos={<GraficosBasicos dashboard={dashboard} />}
            filtrosExtras={(
                <>
                    <Campo label="Resumo">
                        <input type="text" value={filtros.resumo} onChange={e => setFiltro("resumo", e.target.value)}
                            placeholder="Buscar por resumo" className={INPUT_CLASS} />
                    </Campo>
                    <Campo label="Tipo de Serviço">
                        <CustomDropdown value={filtros.tipoServicoId} onChange={e => setFiltro("tipoServicoId", e.value)} options={tiposServico}
                            optionValue="id" optionLabel="nome" placeholder="Todos os tipos" showClear filter />
                    </Campo>
                    <Campo label="Status">
                        <CustomDropdown value={filtros.status} onChange={e => setFiltro("status", e.value)} options={STATUS_OPTIONS}
                            placeholder="Todos os status" showClear />
                    </Campo>
                    <Campo label="Solicitante">
                        <CustomDropdown value={filtros.solicitanteId} onChange={e => setFiltro("solicitanteId", e.value)} options={usuarios}
                            optionValue="id" optionLabel="nome" placeholder="Todos os solicitantes" showClear filter />
                    </Campo>
                </>
            )}
        >
            <CustomTable
                data={linhas}
                columns={COLUNAS}
                loading={loading}
                pagination
                pageSize={20}
                exportable
                showHeader={false}
                className="text-[11px] border shadow-card rounded-xl"
                exportFilename="dashboard_chamado_ti"
                footer={() => null}
                onRowSelect={(row, e) => navegarComCtrl(navigate, `/solicitacoes/${row.solicitacaoId}`, e)}
            />
        </DashboardProcessoLayout>
    );
}
